<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>This is an about page</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VueChartJS",
  components: {},
  data() {
    return {
      datacollection: null, // instantiating datacollection with null
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped></style>
